import styled, { css } from 'styled-components';
import { getColor, typeScale, StyleVars } from 'core/utils';
import { Link } from 'react-scroll';

export const Wrapper = styled.div`
	padding-top: ${typeScale(2)};
	margin-bottom: 8px;

	@media (max-width: 1023px) {
		padding-top: 0;
	}

	@media (min-width: 1024px) {
		padding: 0;
	}
`;

export const Name = styled.h1`
	font-size: ${typeScale(4)};
	font-weight: 600;
	line-height: 1.2;
	color: ${getColor("gray")};
	margin-bottom: 0;
	margin-top: 0;

	@media (max-width: 767px) {
		font-size: ${typeScale(3)};
		letter-spacing: 0.2px;
	}
`;

const storeBase = css`
	font-size: ${typeScale(2)};
	color: ${getColor("gray")};
	line-height: 1.2;
	margin-bottom: ${typeScale(1)};
	margin-top: 0;
	text-decoration: underline;

	@media (max-width: 767px) {
		font-size: ${typeScale(1.7)};
		letter-spacing: 0.2px;
	}
`;

export const Store = styled.a`
	${storeBase};
`;

export const StoreLink = styled(Link)`
	${storeBase};
	cursor: pointer;
`;

export const Intro = styled.div`
	font-size: ${typeScale(2)};
	line-height: 1.4;
	letter-spacing: 0.2px;
	margin-bottom: 4px;
	color: ${getColor("gray")};
`;


export const Row = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const ShareAndLike = styled.div`
	display: flex;
	align-items: center;
`;

export const AdminLink = styled.a`
	display: flex;
	align-items: center;
`;

export const FlairTagContainer = styled.div`
	margin-bottom: 16px;
`;

export const MarketingBadge = styled.div`
	margin-top:	16px;
	margin-bottom: 8px;
	font-size: 10px;
	font-weight: 700;
	display: block;

	@media (max-width: ${StyleVars.screenSm}) {
		margin-top: 0px;
	}	
`;

export const RatesAndSales = styled.div`
	display: flex;
	align-items: center;
`;

export const NumSales = styled.div`
	margin-right: 5px;	
	font-size: 14px;
	line-height: 24px;

	&:after {
		content: '|';
		color: #c7c7c7;
		margin-left: 5px;
	}

	@media (max-width: ${StyleVars.screenXsm}) {
		margin-top: 5px;
	}
`;
